import React from "react";

import Paper from "@material-ui/core/Paper";
import { Grid, Button } from "@material-ui/core";
import { CloudDownload } from "@material-ui/icons";
import Typography from "@material-ui/core/Typography";
import FlightIcon from "@material-ui/icons/Flight";
import moment from "moment";
import axios from "axios";

import SegmentDetail from "../../../../../Flight/SegmentDetailKiwi";
import classes from "./FlightOrderCard.module.css";
import airportData from "../../../../../Flight/data.json";
import { getDateDifference } from "../../../../../../helpers/date.helper";

export default function OrderCard({ order, props }) {
  if (!order) return "No Order Data!";
  const { flight_data: flight, currency, status, order_amount } = order;
  const airlines = [
    ...new Set(
      flight?.segments
        ?.map((segment) => segment.airline)
        .filter((airline) => !!airline) || []
    ),
  ];
  const price = `${currency} ${parseFloat(order_amount).toFixed(2)}`;

  const downloadTicket = (booking_id) => {
    if (!booking_id) return;
    try {
      axios
        .get(`/flights/download-ticket-tbo?booking_id=${booking_id}`, {
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `ticket${booking_id}.pdf`); //or any other extension
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
    } catch (err) {
      console.log(err);
    }
  };

  if (!flight || !airlines || airlines.length === 0) return <>Invalid Data</>;

  return (
    <div className={classes["flight-order-card"]}>
      <Grid item xs="12">
        <Paper className={classes.control} elevation={0}>
          <Grid container>
            <Grid item xs="12" sm="12" style={{ textAlign: "left" }}>
              <Grid container style={{ marginBottom: "0px" }}>
                <Grid item sm="8" xs="10">
                  <Grid container>
                    <Grid item xs="12">
                      <Grid container>
                        <Grid item sm="2" xs="2">
                          <img
                            title={
                              airlines.length > 1
                                ? "Multiple Airlines"
                                : airportData[flight.segments[0].airline]
                                ? airportData[flight.segments[0].airline].name
                                : "Not Available"
                            }
                            height="48px"
                            width="48px"
                            src={
                              airlines.length > 1
                                ? "https://www.gstatic.com/flights/airline_logos/70px/multi.png"
                                : `https://images.kiwi.com/airlines/64/${flight.segments[0].airline}.png`
                            }
                            class="jsx-1041521223"
                            alt="flight order card"
                          />
                        </Grid>
                        <Grid item sm="10" xs="10">
                          <Typography
                            style={{
                              fontWeight: "bold",
                              fontSize: "16px",
                            }}
                          >
                            {moment(
                              flight.segments[0].local_departure
                                .replaceAll("/", "-")
                                ?.split(".")[0]
                            ).format("LT")}{" "}
                            -{" "}
                            {moment(
                              flight.segments[0].local_arrival
                                .replaceAll("/", "-")
                                ?.split(".")[0]
                            ).format("LT")}
                          </Typography>

                          <Typography style={{ fontSize: "14px" }}>
                            {airlines.length > 1
                              ? airlines
                                  .map((airline) => airportData[airline]?.name)
                                  .join(", ")
                              : airportData[flight.segments[0].airline]?.name}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    style={{ marginBottom: "20px", marginTop: "15px" }}
                  >
                    {flight.segments.map((segment, index) => {
                      return (
                        <>
                          <SegmentDetail
                            dark={true}
                            segment={segment}
                            index={index}
                            segments={flight.segments}
                            show_extra_info={false}
                          />
                        </>
                      );
                    })}
                  </Grid>
                </Grid>

                <Grid item sm="4" xs="2">
                  <Grid container>
                    <Grid item xs="12">
                      <Typography stle={{ fontSize: "14px" }}>
                        {" "}
                        <FlightIcon /> {flight.origin} - {flight.destination}
                      </Typography>
                    </Grid>
                    <Grid item xs="12">
                      <Typography
                        style={{ fontWeight: "bold", fontSize: "16px" }}
                      >
                        {" "}
                        {flight.segments.length === 1
                          ? "Direct"
                          : flight.segments.length - 1 + " Stop"}
                      </Typography>
                      <Typography style={{ fontSize: "16px", color: "black" }}>
                        {" "}
                        Order Date Time :{" "}
                        {moment(order.createdAt).format("YYYY-MM-DD HH:MM:SS")}
                      </Typography>
                      <Typography style={{ fontSize: "16px", color: "black" }}>
                        {" "}
                        Amount : {order.order_amount && price}
                      </Typography>
                      {props.userLoginType === "vendor" ||
                      props.userLoginType === "admin" ? (
                        <Typography
                          style={{ fontSize: "16px", color: "black" }}
                        >
                          {" "}
                          Price : {currency}{" "}
                          {parseFloat(order.amount).toFixed(2)}
                        </Typography>
                      ) : (
                        <></>
                      )}

                      {status === "CONFIRMED" ||
                      status === "SCHEDULE_CHANGE" ? (
                        <>
                          {" "}
                          <span
                            className={"badge badge-success"}
                            style={{ color: "var(--darker)" }}
                          >
                            {" "}
                            {status}{" "}
                          </span>{" "}
                          <br />
                          <Button
                            color="primary"
                            variant="contained"
                            size="small"
                            style={{ color: "var(--darker)" }}
                            onClick={() => downloadTicket(order.booking_id)}
                          >
                            <CloudDownload /> &nbsp;Download Ticket
                          </Button>
                          <br />
                          {props.userLoginType === "admin" ||
                          localStorage.getItem("userLoginType") == "admin" ? (
                            <>
                              <span>
                                Agent Name: {order.vendorDetails.name}
                              </span>
                              <br />
                              <span>
                                Agent EmailId: {order.vendorDetails.emailId}
                              </span>
                              <br />
                              <span>
                                Agent Phone: {order.vendorDetails.phone_number}
                              </span>
                              <br />
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : (
                        <span
                          className={
                            status === "FAILED"
                              ? "badge badge-danger"
                              : status === "RECEIVED"
                              ? "badge badge-info"
                              : "badge badge-warning"
                          }
                          style={{ color: "var(--darker)" }}
                        >
                          {" "}
                          {status}{" "}
                        </span>
                      )}
                    </Grid>
                    {flight.segments.length > 1 &&
                      flight.segments.map((segment, index) =>
                        index !== flight.segments.length - 1 ? (
                          <Grid item xs="12">
                            <Typography style={{ fontSize: "14px" }}>
                              {getDateDifference(
                                flight.segments[index + 1].utc_departure,
                                segment.utc_arrival
                              ) +
                                " " +
                                segment.flyTo}
                            </Typography>
                          </Grid>
                        ) : (
                          <></>
                        )
                      )}
                  </Grid>
                </Grid>
                <Grid item sm="12" md="12">
                  <Typography component="p">Passengers</Typography>

                  <table
                    className="table table-sm dense passenger-list-tbl"
                    style={{ color: "black", fontSize: "14px" }}
                  >
                    <thead>
                      <tr>
                        <td>Name</td>
                        <td>Email</td>
                        <td>Phone</td>
                        <td>DOB</td>
                        <td>Category</td>
                        <td>Card No</td>
                        <td>Card Expiry</td>
                        <td>Nationality</td>
                      </tr>
                    </thead>
                    <tbody>
                      {order.passenger_data &&
                        order.passenger_data.length &&
                        order.passenger_data.map((pass, i) => (
                          <tr>
                            <td>
                              {" "}
                              <Typography
                                component="p"
                                style={{ textTransform: "capitalize" }}
                              >
                                {pass?.title} {pass?.name} {pass?.surname}
                              </Typography>
                            </td>
                            <td>
                              {" "}
                              <Typography component="p">
                                {pass?.email}
                              </Typography>{" "}
                            </td>
                            <td>
                              {" "}
                              <Typography component="p">
                                {pass?.phone}{" "}
                              </Typography>{" "}
                            </td>
                            <td>
                              {" "}
                              <Typography component="p">
                                {pass?.birthday}{" "}
                              </Typography>{" "}
                            </td>
                            <td>
                              {" "}
                              <Typography component="p">
                                {pass?.category?.toUpperCase()}{" "}
                              </Typography>{" "}
                            </td>
                            <td>
                              {" "}
                              <Typography component="p">
                                {pass?.cardno}{" "}
                              </Typography>{" "}
                            </td>
                            <td>
                              {" "}
                              <Typography component="p">
                                {pass?.expiration}{" "}
                              </Typography>{" "}
                            </td>
                            <td>
                              {" "}
                              <Typography component="p">
                                {pass?.nationality?.toUpperCase()}{" "}
                              </Typography>{" "}
                            </td>
                          </tr>
                        ))}
                      {order?.passenger_data?.passengers &&
                        order?.passenger_data?.passengers.length &&
                        order?.passenger_data?.passengers.map((pass, i) => (
                          <tr>
                            <td>
                              {" "}
                              <Typography
                                component="p"
                                style={{ textTransform: "capitalize" }}
                              >
                                {pass?.title} {pass?.name} {pass?.surname}
                              </Typography>
                            </td>
                            <td>
                              {" "}
                              <Typography component="p">
                                {pass?.email}
                              </Typography>{" "}
                            </td>
                            <td>
                              {" "}
                              <Typography component="p">
                                {pass?.phone}{" "}
                              </Typography>{" "}
                            </td>
                            <td>
                              {" "}
                              <Typography component="p">
                                {pass?.birthday}{" "}
                              </Typography>{" "}
                            </td>
                            <td>
                              {" "}
                              <Typography component="p">
                                {pass?.category?.toUpperCase()}{" "}
                              </Typography>{" "}
                            </td>
                            <td>
                              {" "}
                              <Typography component="p">
                                {pass?.cardno}{" "}
                              </Typography>{" "}
                            </td>
                            <td>
                              {" "}
                              <Typography component="p">
                                {pass?.expiration}{" "}
                              </Typography>{" "}
                            </td>
                            <td>
                              {" "}
                              <Typography component="p">
                                {pass?.nationality?.toUpperCase()}{" "}
                              </Typography>{" "}
                            </td>
                          </tr>
                        ))}{" "}
                    </tbody>
                  </table>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </div>
  );
}
